(function () {
  var mql = window.matchMedia('(max-width: 767px)');
  var stickyClass = 'alilao-mobile-toolbar-sticky';
  var observer = null;
  var fallbackBound = false;

  function getToolbar() {
    return document.querySelector('.site-header-toolbar');
  }

  function getSentinel() {
    return document.querySelector('.alilao-mobile-toolbar-sentinel');
  }

  function initHeaderSearchFocus() {
    var searchContainer = document.querySelector('.site-header-search');

    if (!searchContainer || searchContainer.dataset.searchFocusBound === 'true') {
      return;
    }

    searchContainer.dataset.searchFocusBound = 'true';
    searchContainer.addEventListener('click', function () {
      var searchInput = searchContainer.querySelector('input[type="search"], input[type="text"]');

      if (searchInput) {
        searchInput.focus();
      }
    });
  }

  function updateToolbarHeight() {
    var toolbar = getToolbar();

    if (!toolbar || !mql.matches) {
      document.documentElement.style.removeProperty('--mobile-toolbar-height');
      return;
    }

    document.documentElement.style.setProperty('--mobile-toolbar-height', Math.round(toolbar.getBoundingClientRect().height) + 'px');
  }

  function setStickyState(isSticky) {
    document.documentElement.classList.toggle(stickyClass, Boolean(isSticky) && mql.matches);
    updateToolbarHeight();
  }

  function evaluateFallbackStickyState() {
    var sentinel = getSentinel();

    if (!sentinel || !mql.matches) {
      setStickyState(false);
      return;
    }

    setStickyState(sentinel.getBoundingClientRect().top <= 0);
  }

  function teardownObserver() {
    if (observer) {
      observer.disconnect();
      observer = null;
    }

    if (fallbackBound) {
      window.removeEventListener('scroll', evaluateFallbackStickyState);
      fallbackBound = false;
    }

    setStickyState(false);
  }

  function setupObserver() {
    var sentinel = getSentinel();

    teardownObserver();
    updateToolbarHeight();

    if (!sentinel || !mql.matches) {
      return;
    }

    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(function (entries) {
        var entry = entries && entries[0];
        setStickyState(Boolean(entry) && entry.intersectionRatio === 0 && entry.boundingClientRect.top <= 0);
      }, {
        threshold: [0, 1]
      });

      observer.observe(sentinel);
      return;
    }

    fallbackBound = true;
    window.addEventListener('scroll', evaluateFallbackStickyState, { passive: true });
    evaluateFallbackStickyState();
  }

  function init() {
    setupObserver();
    initHeaderSearchFocus();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('resize', updateToolbarHeight);
  window.addEventListener('resize', setupObserver);
  document.addEventListener('shopify:section:load', init);

  if (mql.addEventListener) {
    mql.addEventListener('change', setupObserver);
  } else if (mql.addListener) {
    mql.addListener(setupObserver);
  }
})();
